import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { getThemeProps, useTheme } from '@material-ui/styles';
import useEnhancedEffect from '../utils/useEnhancedEffect';
export default function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = useTheme();
  var props = getThemeProps({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (process.env.NODE_ENV !== 'production') {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _extends2 = _extends({}, props, options),
      _extends2$defaultMatc = _extends2.defaultMatches,
      defaultMatches = _extends2$defaultMatc === void 0 ? false : _extends2$defaultMatc,
      _extends2$matchMedia = _extends2.matchMedia,
      matchMedia = _extends2$matchMedia === void 0 ? supportMatchMedia ? window.matchMedia : null : _extends2$matchMedia,
      _extends2$noSsr = _extends2.noSsr,
      noSsr = _extends2$noSsr === void 0 ? false : _extends2$noSsr,
      _extends2$ssrMatchMed = _extends2.ssrMatchMedia,
      ssrMatchMedia = _extends2$ssrMatchMed === void 0 ? null : _extends2$ssrMatchMed;

  var _React$useState = React.useState(function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      match = _React$useState2[0],
      setMatch = _React$useState2[1];

  useEnhancedEffect(function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query: query,
      match: match
    });
  }

  return match;
}